/** Сообщить меню кабинета, что число опросов или сессий изменилось: счётчики перечитаются с сервера. */
export const COUNTS_CHANGED_EVENT = 'svod:counts-changed';

export function notifyCountsChanged() {
    window.dispatchEvent(new Event(COUNTS_CHANGED_EVENT));
}
